import { render, staticRenderFns } from "./professional.vue?vue&type=template&id=11a85201&scoped=true&"
import script from "./professional.vue?vue&type=script&lang=js&"
export * from "./professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a85201",
  null
  
)

export default component.exports